<ion-card id="card">
  <ion-card-header>
    <ion-card-subtitle>
      {{ setPregunta }}
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <caritas
      [setPregunta]="setPregunta"
      (valueEmit)="cambioCaritas($event)"
    ></caritas>

    <p class="question">{{ setPregunta2 }}</p>

    <texto
      [setPregunta]="setPregunta2"
      (valueEmit)="cambioTexto($event)"
      [tamano]="longitud"
      [isEnabled]="isEnabled"
    ></texto>
  </ion-card-content>
</ion-card>
